import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const indoorExercisePlayAge2: BlogMetaData = {
  title: '2歳児の運動遊び10選｜室内でできる体を動かす遊び（モンテッソーリ視点）',
  description:
    '2歳児が室内でできる運動遊びを10選紹介。準備なしですぐできる遊びからサーキット遊びまで、モンテッソーリの運動の敏感期を活かした体の動かし方と保護者の声かけも解説します。',
  thumbnailUrl: '/img/blog-indoor-exercise-play-age-2.webp',
  filePath: buildBlogFilePath('indoor-exercise-play-age-2'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
